import React from 'react'
import PropTypes from 'prop-types'
import LeagueHistoryCard from './LeagueHistoryCard'

export default function LeagueHistoryList({
  leagues,
  expandedLeagueIds,
  toggleLeague,
  pid,
  leagueContext = null,
}) {
  if (leagues.length === 0) {
    return (
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center py-5">
              <h5>No League History</h5>
              <p className="text-muted">
                This player hasn&apos;t participated in any leagues yet.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return leagues.map((leagueData) => (
    <LeagueHistoryCard
      key={leagueData.league.id}
      leagueData={leagueData}
      isExpanded={expandedLeagueIds.has(leagueData.league.id)}
      toggleLeague={toggleLeague}
      pid={pid}
      leagueContext={leagueContext}
    />
  ))
}

LeagueHistoryList.propTypes = {
  leagues: PropTypes.arrayOf(
    PropTypes.shape({
      league: PropTypes.object.isRequired,
      matches: PropTypes.array.isRequired,
      divisions: PropTypes.array.isRequired,
    }),
  ).isRequired,
  expandedLeagueIds: PropTypes.instanceOf(Set).isRequired,
  toggleLeague: PropTypes.func.isRequired,
  pid: PropTypes.number.isRequired,
  leagueContext: PropTypes.shape({
    leagueId: PropTypes.number,
    divisionId: PropTypes.number,
  }),
}
